import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
//
// Tokens
//
export const CFBaseDividerTokens = {
    COLOR: {
        alternate: CFTokens.COLOR.BORDER_ALTERNATE_DEFAULT,
        default: CFTokens.COLOR.BORDER_SUBTLE,
        'ink-16': CFTokens.COLOR.INK_16,
        'salt-32': CFTokens.COLOR.SALT_32,
        warm: CFTokens.COLOR.BORDER_WARM,
    },
    SIZE: {
        medium: 4,
        thick: 8,
        thin: 1,
    },
};
//
// Helpers
//
export const CFBaseDividerHelpers = {
    borderColor: ({ color }) => {
        return CFBaseDividerTokens.COLOR[color];
    },
    borderSide: ({ dir }) => {
        if (dir === 'vertical') {
            return css `
        border-top-width: 0;
        border-right-width: 0;
        border-bottom-width: 0;
      `;
        }
        return css `
      border-top-width: 0;
      border-right-width: 0;
      border-left-width: 0;
    `;
    },
    borderSize: ({ size = 'thin', dir }) => {
        if (dir === 'vertical') {
            return CFBaseDividerTokens.SIZE.thin;
        }
        return CFBaseDividerTokens.SIZE[size];
    },
    boxSize: ({ dir }) => {
        if (dir === 'vertical') {
            return css `
        height: 100%;
        width: 0;
      `;
        }
        return css `
      height: 0;
      width: 100%;
    `;
    },
};
//
// Element Styles
//
export const CFBaseDividerStyles = {
    Root: css `
    margin: 0;
    padding: 0;
    ${CFBaseDividerHelpers.boxSize};
    align-self: stretch;
    background-color: transparent;
    border-width: ${CFBaseDividerHelpers.borderSize}px;
    ${CFBaseDividerHelpers.borderSide};
    border-style: solid;
    border-color: ${CFBaseDividerHelpers.borderColor};
  `,
};
